var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('spaces-list',{attrs:{"item-type":"challenges","item-type-single":"challenge"}})}
var staticRenderFns = []

export { render, staticRenderFns }